<template>
  <div class="s-alert" :class="`s-alert--${type}`">
    <sdui-icon class="s-alert__icon icon-28" :class="iconName" />

    <div class="s-alert__container">
      <div v-if="$hasSlotContent($slots['header']) || title" class="s-alert__header">
        <slot name="header">
          <p class="h4 m-0 s-alert__title">{{ title }}</p>
        </slot>
      </div>

      <div v-if="$hasSlotContent($slots['default']) || description" class="s-alert__content">
        <slot name="default">
          <SText>{{ description }}</SText>
        </slot>
      </div>

      <div v-if="$hasSlotContent($slots['footer'])" class="s-alert__footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import SText from 'src/components/base/SText.vue'

export default {
  name: 'SAlert',
  components: { SText },

  props: {
    title: {
      type: String,
      default: undefined,
    },

    description: {
      type: String,
      default: undefined,
    },

    type: {
      type: String,
      default: 'info',
      validator: (value) => ['info', 'warning', 'danger', 'success'].includes(value),
    },
  },

  computed: {
    iconName() {
      return this.type === 'success' ? 'icon-check' : 'icon-message-warning'
    },
  },
}
</script>

<style scoped lang="scss">
.s-alert {
  $--card-border: 1px solid;
  $--card-border-radius: 1rem;

  // default colors (info variant)
  --card-border-color: #e2e2e2;
  --card-background-color: #f1f1f1;
  --card-icon-color: #0077cc;

  display: flex;
  border-radius: $--card-border-radius;
  border: $--card-border;
  padding: 0.75rem;
  gap: 0.75rem;
  border-color: var(--card-border-color);
  background-color: var(--card-background-color);

  .s-alert__icon {
    color: var(--card-icon-color);
  }

  &--warning {
    --card-border-color: #d67200;
    --card-background-color: #faefe2;
    --card-icon-color: #d67200;
  }

  &--danger {
    --card-border-color: #e92c2c;
    --card-background-color: #fdeded;
    --card-icon-color: #e92c2c;
  }

  &--success {
    --card-border-color: #00a32e;
    --card-background-color: #e3f5e8;
    --card-icon-color: #00a32e;
  }

  &__header {
    padding: 0;
  }

  &__content {
    padding: 0.5rem 0;
  }

  &__footer {
    padding: 0;
  }

  .s-alert__title {
    color: $color-gray-400;
    font-size: pxtorem(17);
    font-weight: $font-weight-bolder;
    line-height: pxtorem(20);
    letter-spacing: -0.2px;
  }
}
</style>
